export default __webpack_public_path__ + "static/stacks-7ea4cfcb62d5e9e4007c21829e360e51.svg";